import { render, staticRenderFns } from "./ActionHistoryTable.vue?vue&type=template&id=12cb56fc&scoped=true"
import script from "./ActionHistoryTable.vue?vue&type=script&lang=js"
export * from "./ActionHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb56fc",
  null
  
)

export default component.exports